import { fetchAchievements } from "../services/achievementsService";
import { Achievement } from "../types/achievements";
import { usePublicData } from "./usePublicData";

export interface UseAchievementsResult {
  achievements: Achievement[];
  loading: boolean;
  error: string | null;
}

export default function useAchievements(pilotUid: string | null = null): UseAchievementsResult {
  const result = usePublicData(`achievements:${pilotUid ?? ""}`, () => fetchAchievements(pilotUid ?? undefined));
  return { achievements: result.data?.achievements ?? [], loading: result.loading, error: result.error ?? null };
}
